"use client";
import styles from "./index.module.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ChatSkeleton = () => {
  return (
    <div className={styles.skeletonWrapper}>
      {[...Array(10)].map((_, i) => {
        const isLeft = i % 2 === 0; // simulate other user vs self
        const showDateSeparator = i % 3 === 0;

        const lineWidths = isLeft
          ? ["60%", "40%"] // other user
          : ["80%", "55%"]; // self

        return (
          <div key={i}>
            {showDateSeparator && (
              <div className={styles.skeletonDateSeparator}>
                <div className={styles.line}></div>
                <Skeleton
                  width={80}
                  height={12}
                  borderRadius={6}
                  className={styles.skeletonDateText}
                />
                <div className={styles.line}></div>
              </div>
            )}

            <div
              className={`${styles.skeletonRow} ${
                isLeft ? styles.left : styles.right
              }`}
            >
              {isLeft && (
                <Skeleton
                  circle
                  width={32}
                  height={32}
                  className={styles.skeletonAvatar}
                />
              )}
              <div
                className={`${styles.skeletonBubble} ${
                  isLeft ? styles.left : styles.right
                }`}
              >
                {lineWidths.map((w, idx) => (
                  <Skeleton
                    key={idx}
                    height={14}
                    width={w}
                    borderRadius={10}
                  />
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};


export default ChatSkeleton;
